/*
  SarhSoft Cross-PlatForm Engine Project
  Lnaguages: PHP, JavaScript, Node, Java.
  BackEnd: Laravel.
  FrontEnd: Vue2.
  Project Type: (Laravel,Vue Mixin) Java Cross Frame.
  Written By: M.Farhat,
  Email: m.farhat@sarhsoft.com.
  Copyright © 2026 SarhSoft All rights reserved.
*/
export default {
  transaction_type:      'نوع العملية',
  vendor_transaction_id: 'مصدر العملية',
  vendor_response:       'رد المصدر',
  transaction_date:      'تاريخ العملية',
  is_succeeded:          'ناجحة',
};
